module.exports = "<% if (!GLOBALS.IS_LAZY_USER) { %>\n  <div class=\"alert mh-alert animated bounceInRight\">\n    <div class=\"icon-lightbulb\"><div>💡</div></div>\n    <div class=\"tip-content\">\n      <span class=\"title \">Moodhacker Tip: </span>\n      Download our <a href=\"<%= GLOBALS.IOS_URL %>\">iOS</a> or <a href=\"<%= GLOBALS.ANDROID_URL %>\">Android</a> app\n      to get reminders and make tracking easy.\n    </div>\n  </div>\n<% } %>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./web/templates/js/notification-tip.html
// module id = 154
// module chunks = 0